// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wizard-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.wizard-modal {
  width: 480px;
  max-width: 90%;
  padding: 32px;
  position: relative;
  border-radius: 12px;
}

.wizard-modal h2 {
  margin-top: 0;
  margin-bottom: 24px;
}

label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 16px;
  font-size: 0.9rem;
}

label input,
label select {
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 0.9rem;
}

.steps {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  position: relative;
  margin-bottom: 24px;
}

.step-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #e0e0e0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.9rem;
  font-weight: 600;
  color: #555;
  position: relative;
  z-index: 1;
}
.step-circle.active {
  background: #007bff;
  color: #fff;
}
.step-circle.done {
  background: #28a745;
  color: #fff;
}

.steps::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 16px;
  right: 16px;
  height: 2px;
  background: #e0e0e0;
  z-index: 0;
}

.wizard-actions {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.wizard-actions button {
  min-width: 90px;
}

.close-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  background: transparent;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255,255,255,0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
}
.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
} `, "",{"version":3,"sources":["webpack://./src/pages/css/OrgSetupWizard.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;AACA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC","sourcesContent":[".wizard-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0,0,0,0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.wizard-modal {\n  width: 480px;\n  max-width: 90%;\n  padding: 32px;\n  position: relative;\n  border-radius: 12px;\n}\n\n.wizard-modal h2 {\n  margin-top: 0;\n  margin-bottom: 24px;\n}\n\nlabel {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 16px;\n  font-size: 0.9rem;\n}\n\nlabel input,\nlabel select {\n  padding: 10px 12px;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n  font-size: 0.9rem;\n}\n\n.steps {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 24px;\n  position: relative;\n  margin-bottom: 24px;\n}\n\n.step-circle {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: #e0e0e0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #555;\n  position: relative;\n  z-index: 1;\n}\n.step-circle.active {\n  background: #007bff;\n  color: #fff;\n}\n.step-circle.done {\n  background: #28a745;\n  color: #fff;\n}\n\n.steps::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 16px;\n  right: 16px;\n  height: 2px;\n  background: #e0e0e0;\n  z-index: 0;\n}\n\n.wizard-actions {\n  margin-top: 24px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.wizard-actions button {\n  min-width: 90px;\n}\n\n.close-btn {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: transparent;\n  border: none;\n  font-size: 1.2rem;\n  cursor: pointer;\n}\n\n.loading-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(255,255,255,0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px;\n}\n.spinner {\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #007bff;\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n  animation: spin 1s linear infinite;\n}\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
